<template>
  <div class="charts-block">
    <div class="charts-block__header">
      <div class="charts-block__header-title">{{ info.title }}</div>
    </div>
    <div class="charts-block__body">
      <apexcharts v-if="info.type === 'bar'"
          width="100%"
          height="300px"
          :options="columnChart.options"
          :series="columnChart.series"
      />

      <apexcharts v-else
          width="100%"
          height="300px"
          :options="pieChart.options"
          :series="pieChart.series"
      />
    </div>
  </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  import analyticFormatData from '@/mixins/analyticFormatData'

  export default {
    name: 'CustomersChartBlock',
    props: ['info', 'period', 'chartData'],
    mixins: [analyticFormatData],
    components: {
      apexcharts: VueApexCharts
    },
    computed: {
      columnChart() {
        const chartOpts = {
          series: [{
            name: `${ this.info.title.split(' ').shift() } users`,
            data: []
          }],
          options: {
            chart: {
              type: this.info.type,
              animations: {speed: 200},
              toolbar: {show: false}
            },
            noData: {
              text: 'No data for current period'
            },
            plotOptions: {bar: {horizontal: false, columnWidth: '15px'}},
            dataLabels: {enabled: true, position: 'top'},
            grid: {show: false},
            legend: {show: false},
            stroke: {width: 1},
            xaxis: {categories: []},
            yaxis: {labels: {show: true}},
            tooltip: {y: {formatter: value => Number(value)}}
          }
        }

        if (this.chartData) {
          this.chartData.forEach(item => {
            chartOpts.series[0].data.push(item.count)
            chartOpts.options.xaxis.categories.push(item.label > 9 ? `${item.label}:00` : `0${item.label}:00`)
          })
        } else {
          chartOpts.series[0].data.push(0)
          chartOpts.options.xaxis.categories.push(this.date().time)
        }

        return chartOpts
      },
      pieChart() {
        const chartOpts = {
          series: [],
          options: {
            chart: {
              type: this.info.type,
              animations: { speed: 200 },
              toolbar: { show: false }
            },
            noData: {
              text: 'No data for current period'
            },
            labels: [],
            colors:['#008ffb', '#05c181', '#feb019', '#dc0020', '#775dd0'],
            dataLabels: {
              enabled: true
            },
            grid: { show: false },
            legend: {
              position: 'right',
              showForNullSeries: true,
              showForZeroSeries: true,
              formatter: (name, opts) => [name, " - ", opts.w.globals.series[opts.seriesIndex]]
            },
            stroke: { width: 1 }
          }
        }

        if (this.chartData && !this.chartData.every(item => item.count === 0)) {
          this.chartData.forEach(item => {
            chartOpts.series.push(item.count)
            chartOpts.options.labels.push(item.label)
          })
        } else chartOpts.series = []

        return chartOpts
      }
    }
  }
</script>

<style lang="scss" scoped>
  .charts-block {
    display: flex;
    flex-direction: column;
    align-content: center;
    width: 50%;
    border: 1px solid #E4E7ED;
    border-radius: 5px;
    padding: 5px;
    margin: 5px;


    @media (max-width: 1024px) {
      width: 95%;
    }

    @media (max-width: 550px) {
      width: 93%;
    }

    &__header {
      display: flex;
      justify-content: space-between;
      padding: 10px;

      &-title {
        font-size: 18px;
        font-weight: 600;
        color: #3366cd;
      }

      &-info {
        font-size: 14px;
        font-weight: 500;
        color: #4a596abd;
        display: flex;
        align-items: center;

        @media (max-width: 550px) {
          font-size: 10px;
        }
      }
    }
  }
</style>
